import { render } from "./VerificationResult.vue?vue&type=template&id=0f326368&scoped=true"
import script from "./VerificationResult.vue?vue&type=script&lang=js"
export * from "./VerificationResult.vue?vue&type=script&lang=js"

import "./VerificationResult.vue?vue&type=style&index=0&id=0f326368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f326368"]])

export default __exports__